module.exports = __webpack_public_path__ + "img/step3_qq.6c9497ba.png";